import React from 'react';
import { useLostPwd } from './api/useLostPwd';
import { LostPwdComponent as LostPwd } from './components/lostPwd.component';

export const LostPwdPage = () => {
    const { mutate: requestNewPwd } = useLostPwd();

    return <LostPwd requestNewPwd={requestNewPwd} />;
};
